import newAccount from './newAccount.js';
import UserCookieService from './userCookieService.js';
import LegacyUserCookieService from './legacyUserCookieService.js';
import {storage} from '@nuskin/ns-util';

// This class is used to go between Market/Micro site authentication and LTO authentication.
/**
 *
 * UserService
 *
 * @namespace UserService
 */
newAccount.UserService = new function(){
    let isCurrentPageLTOSite = window.location.href.indexOf('/content/lto') !== -1;

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {

        /**
         * @memberof UserService
         * @example
         * UserService.isLTOSite()
         * @returns {boolean} isLTOSite
         */
        isLTOSite : function(){
            return isCurrentPageLTOSite;
        },

        /**
         * @memberof UserService
         * @example
         * UserService.isLoggedIn()
         * @returns {boolean} isLoggedIn
         */
        isLoggedIn: function(){
            return UserCookieService.isLoggedIn();
        },

        /**
         * @memberof UserService
         * @example
         * UserService.setLoggedIn(isNative)
         * @param {boolean} isNative
         */
        setLoggedIn: function(isNative){
            UserCookieService.setLoggedIn(isNative);
        },

        /**
         * @memberof UserService
         * @example
         * UserService.getUser()
         * @returns {object} user
         */
        getUser: function(){
            if (isCurrentPageLTOSite){
                // This is for LTO's
                return UserCookieService.getUser();
            }
            else{
                // This is for Market / Micro sites.
                return LegacyUserCookieService.getUser();
            }
        },

        /**
         * @memberof UserService
         * @example
         * UserService.isVolumesLoaded()
         * @returns {boolean} isVolumesLoaded
         */
        isVolumesLoaded: function(){
            let volumesLoaded = true;
            try {
                let isloaded = this.getUser().isVolumesLoaded;
                if(typeof (isloaded) !== 'undefined') {
                    volumesLoaded = isloaded;
                }
            } catch(e) {} // eslint-
            return volumesLoaded;
        },

        /**
         * @memberof UserService
         * @example
         * UserService.showEmailVerify()
         * @returns {boolean} showEmailVerify
         */
        showEmailVerify: function(){
            let _showEmailVerify = false;
            try {
                if(this.isLoggedIn()) {
                    let display_cookie = storage.getItem(storage.keys.DISPLAY_EMAIL_VERIFY);
                    if (display_cookie !== undefined && display_cookie == null) {
                        if(!this.getUser().emailVerified && this.getUser().emailNeedsVerify) {
                            _showEmailVerify = true;
                        }
                    }
                }

            } catch(e) {}
            return _showEmailVerify;
        },

        /**
         * @memberof UserService
         * @example
         * UserService.isHomeMarket()
         * @returns {boolean} isHomeMarket
         */
        isHomeMarket: function(country){
            let _isHomeMarket = false;
            if(this.isLoggedIn()) {
                let cntryCd = this.getUser().countryCd;
                if (typeof (cntryCd) !== 'undefined' && country) {
                    if(cntryCd == country) {
                        _isHomeMarket = true;
                    } else if((country == "PF" || country == "NC") && cntryCd == "NZ") {
                        _isHomeMarket = true;
                    }
                }
            }
            return _isHomeMarket;
        },

        /**
         * @memberof UserService
         * @example
         * UserService.setUser(user)
         * @param {object} user
         */
        setUser: function(user){
            // This is for LTO's
            UserCookieService.setUser(user);

            // This is for Market / Micro sites.
            LegacyUserCookieService.setUser(user);
        },

        /**
         * @memberof UserService
         * @example
         * UserService.resetUserStorage()
         */
        resetUserStorage: function(){
            // This is for LTO's
            UserCookieService.resetUserStorage();

            // This is for Market / Micro sites.
            LegacyUserCookieService.resetUserStorage();
        },

        /**
         * @memberof UserService
         * @example
         * UserService.getStoredUser()
         * @returns {object} user
         */
        getStoredUser: function(){
            if (isCurrentPageLTOSite){
                // This is for LTO's
                return UserCookieService.getStoredUser();
            }
            else{
                // This is for Market / Micro sites.
                return LegacyUserCookieService.getStoredUser();
            }
        },

        /**
         * @memberof UserService
         * @example
         * UserService.writeUserToStorage(user)
         * @param {object} user
         */
        writeUserToStorage: function(user){
            // This is for LTO's
            UserCookieService.writeUserToStorage(user);

            // This is for Market / Micro sites.
            LegacyUserCookieService.writeUserToStorage(user);
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------

    return publicMethods;
}();

export default newAccount.UserService;
